import { useTranslation } from 'react-i18next';
import { comments } from '@/mocks/comments';

interface CommentsSectionProps {
  animeId: number;
}

export default function CommentsSection({ animeId }: CommentsSectionProps) {
  const { t } = useTranslation();

  const animeComments = comments.filter((c) => c.animeId === animeId);

  return (
    <section className="py-10 md:py-14 bg-background-200/70">
      <div className="px-4 md:px-6">
        <div className="mb-8">
          <span className="inline-block bg-accent-100 text-accent-900 text-xs font-medium px-3 py-1 rounded-lg whitespace-nowrap">
            {t('观众热评')}
          </span>
          <h2 className="text-xl md:text-3xl font-heading text-foreground-900 mt-3 leading-tight">
            {t('追番的朋友都在聊什么')}
          </h2>
        </div>

        <div className="columns-1 md:columns-3 gap-4 space-y-4">
          {animeComments.length > 0 ? (
            animeComments.map((comment) => (
              <div
                key={comment.id}
                className="break-inside-avoid bg-background-50 rounded-lg p-4 md:p-5"
              >
                <div className="flex items-center gap-3 mb-3">
                  <div className="w-10 h-10 rounded-full overflow-hidden flex-shrink-0">
                    <img
                      src={comment.avatar}
                      alt={comment.username}
                      className="w-full h-full object-cover"
                      loading="lazy"
                    />
                  </div>
                  <div>
                    <p className="text-sm font-medium text-foreground-900">{comment.username}</p>
                    <p className="text-xs text-foreground-500">{comment.date}</p>
                  </div>
                </div>
                <p className="text-sm text-foreground-700 leading-relaxed">
                  &ldquo;{comment.content}&rdquo;
                </p>
                <div className="flex items-center gap-1 mt-3">
                  {Array.from({ length: comment.rating }).map((_, i) => (
                    <i key={i} className="ri-star-fill text-accent-500 text-xs"></i>
                  ))}
                </div>
              </div>
            ))
          ) : (
            <div className="break-inside-avoid bg-background-50 rounded-lg p-6 text-center col-span-full">
              <p className="text-foreground-500 text-sm">{t('暂无数据')}</p>
            </div>
          )}
        </div>
      </div>
    </section>
  );
}